<script>
    import Svgo from "./svgo.svelte";
    export let bgcolor = "rgba(0, 10, 31, 0.3)";
</script>

<Svgo {...$$props} on:click>
    <path
        d="M12 23.4001C18.296 23.4001 23.4 18.2961 23.4 12.0001C23.4 5.70405 18.296 0.600098 12 0.600098C5.70393 0.600098 0.599976 5.70405 0.599976 12.0001C0.599976 18.2961 5.70393 23.4001 12 23.4001Z"
        fill={bgcolor}
    /><path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.3171 9.82781C16.7345 10.2452 16.7345 10.9219 16.3171 11.3393L12.7821 14.8743C12.5022 15.1542 12.1057 15.2463 11.749 15.1509C11.5606 15.1073 11.3817 15.0122 11.2348 14.8653L7.69984 11.3303C7.28246 10.913 7.28246 10.2363 7.69984 9.81889C8.11721 9.40152 8.79391 9.40152 9.21128 9.81889L12.0129 12.6205L14.8057 9.82781C15.223 9.41044 15.8997 9.41044 16.3171 9.82781Z"
        fill="currentColor"
    />
</Svgo>
